import React from "react";
import { howDiWorksLib } from "../../lib/data";

// assets
import diGif from "../../assets/GIFs/How-Digital-Infrastructure-Works.gif";

const HowDiWorks = () => {
  return (
    <section id="how-digital-infrastructure-works" className="bg-black">
      <div class="main-padding">
        <div class="main-margin">
          <h1 class="sub-header text-white mb-12">
            How Digital Infrastructure Works
          </h1>
          <p className="text-white mb-12">
            In today’s hyperconnected world, staying in touch feels effortless.
            A tap on your phone, a click on your tablet, and suddenly you’re
            videochatting with loved ones across oceans, streaming the latest
            movie, or browsing a global marketplace.
          </p>
          <div className="grid gap-16 md:grid-cols-2 lg:grid-cols-2 md:gap-8 lg:gap-16">
            <div>
              <img
                src={diGif}
                alt="Visualization of the interconnected role of
                cell phones, fiber networks, and data
                centers in delivering reliable connectivity
                and access to data."
              />
            </div>
            <div>
              {howDiWorksLib.map((a, i) => {
                return (
                  <div className="grid grid-cols-[auto,auto] gap-6 mb-12">
                    <div class="flex items-center justify-center bg-hmcGold text-black font-semibold rounded-full h-10 w-10">
                      {a.number}
                    </div>
                    <p className="text-white">{a.info}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowDiWorks;
